import { Container } from "./styles"
import treepayLogo from '../../assets/back-tree-hands.png'

export default function Aside() {
  return (
    <Container>
        <img id="shadown" src={treepayLogo} alt="Logo treepay" />
        <img src={treepayLogo} alt="Logo treepay" />
    </Container>
  )
}
